<template>
    <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="785"
            persistent>
        <template v-slot:activator="{ on }">
            <v-text-field
                    :label="label? label : 'Select date range'"
                    prepend-inner-icon="event"
                    readonly
                    flat
                    outlined
                    v-if="outlined"
                    hide-details
                    v-on="on"
                    :value="dateValue"
                    clearable
                    @click:clear="clearField"
            ></v-text-field>
            <v-text-field
                    v-else
                    :label="label?label:'Select date range'"
                    prepend-inner-icon="event"
                    readonly
                    flat
                    solo
                    hide-details
                    v-on="on"
                    :value="dateValue"
                    clearable
                    @click:clear="clearField"
            ></v-text-field>
        </template>
        <v-card>
            <v-card-text class="pb-0">
                <v-layout row wrap>
                    <v-flex xs3>
                        <v-list>
                            <v-subheader>Presets</v-subheader>
                            <v-list-item
                                    v-for="(preset, index) in presets"
                                    :key="index"
                                    @click="selectPreset(preset)"
                            >
                                <v-list-item-content
                                        :class="{'font-weight-bold':preset.label === selectedPreset.label}">
                                    {{ preset.label }}
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-flex>
                    <v-flex xs9>
                        <v-layout row wrap>
                            <v-flex xs6 class="pr-2">
                                <v-text-field
                                        label="Start date"
                                        v-mask="dateMask"
                                        v-model="date.start"
                                ></v-text-field>
                                <v-date-picker v-model="date.start" no-title scrollable></v-date-picker>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                        label="End date"
                                        v-model="date.end"
                                        v-mask="dateMask"
                                        :error-messages="errorMessage"
                                ></v-text-field>
                                <v-date-picker v-model="date.end" no-title scrollable></v-date-picker>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" class="text-white" @click="menu = false">Cancel</v-btn>
                <v-btn color="primary" @click="saveDate">OK</v-btn>
            </v-card-actions>
        </v-card>


    </v-menu>

</template>

<script>
    import moment from "moment";
    import {mask} from 'vue-the-mask'

    export default {
        name: "DateRangePickerNew",
        props: ['value','outlined',"label"],
        directives:{
          mask
        },
        data() {
            return {
                date: {
                    start: new Date().toISOString().substr(0, 10),
                    end: new Date().toISOString().substr(0, 10)
                },
                labelDate: {
                    start: null,
                    end: null
                },
                dateMask: '####-##-##',
                menu: false,
                selectedPreset: {},
                presets: [
                    {
                        label: 'Today',
                        range: {
                            start: new Date().toISOString().substr(0, 10),
                            end: new Date().toISOString().substr(0, 10)
                        }
                    },
                    {
                        label: 'Yesterday',
                        range: {
                            start: moment().subtract(1, 'days').format('Y-MM-DD'),
                            end: moment().subtract(1, 'days').format('Y-MM-DD')
                        }
                    },
                    {
                        label: 'Last 30 days',
                        range: {
                            start: moment().subtract(30, 'days').format('Y-MM-DD'),
                            end: moment().subtract(1, 'days').format('Y-MM-DD')
                        }
                    },
                    {
                        label: 'This year',
                        range: {
                            start: new Date().toISOString().substr(0, 5) + '01-01',
                            end: new Date().toISOString().substr(0, 10)
                        }
                    },

                ]

            }
        },
        watch: {
            value(new_value) {
                if (new_value) {
                    this.date = new_value;
                    this.labelDate = new_value;
                }
            }
        },
        computed:
            {
                dateValue() {
                    if (this.labelDate.start && this.labelDate.end) {
                        return this.labelDate.start + ' to ' + this.labelDate.end
                    }
                    return 'Select date range'
                },
                errorMessage() {
                    let errorMessage = '';
                    if (this.date.start && this.date.end) {
                        if (Date.parse(this.date.start) > Date.parse(this.date.end)) {
                            errorMessage = 'End date cannot be greater than start date'
                        }
                    }
                    return errorMessage;
                }
            },
        methods: {
            selectPreset(preset) {
                this.selectedPreset = preset;
                this.date = preset.range;
            },
            saveDate() {
                if (!this.errorMessage) {
                    this.labelDate = this.date;
                    this.$emit('input', this.date);
                    this.$emit('change');
                    this.menu = false;
                }
            },
            clearField() {
                this.$emit('input', null)
            }
        },

    }
</script>
